import type { useFormatter } from 'next-intl';

type Formatter = ReturnType<typeof useFormatter>;

export function formatPublicCurrency(format: Formatter, amount: number, currency: string): string {
  return format.number(amount, {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  });
}

/**
 * Dollar-precision currency formatter for contexts without a next-intl provider
 * (e.g., admin app routes). Matches `formatPublicCurrency` precision rules — no
 * compact notation, no cents — so admin and public surfaces stay aligned.
 */
export function formatDollarCurrency(amount: number, currency: string): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}
